import React, { useEffect } from 'react'

import FeedbackBanner from 'components/Modal Survei/Survei'

import SingleLayout from '../../components/Layouts/SingleLayout'
import { trackSatuEvent } from '../../lib/satu-event-tracker'

export default function DasborPage() {
  // Track page view on mount
  useEffect(() => {
    trackSatuEvent({
      activity_type: 'PAGE_VIEWED',
      page_name: 'DASBOR PENGADUAN PUBLIK',
    })
  }, [])

  return (
    <SingleLayout>
      <div className="flex pt-[160px] md:pt-[120px]">
        <div className="w-full bg-white my-12 p-2 lg:py-12 lg:px-16 min-h-[400px]">
          <iframe
            className="w-full"
            width="600"
            height="1250"
            src="https://lookerstudio.google.com/embed/reporting/1e482b33-cf0f-472b-9e70-261f915afb8f/page/jUH4E"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          ></iframe>
          <FeedbackBanner surveyUrl="https://surveidigital.spbe.go.id/embed/survey/eyJzdXJ2ZXlfaWQiOjIsInNlcnZpY2VfaWQiOjM0OSwiaG9zdCI6Imh0dHBzOi8vdWx0LmtlbWVuZGlrZGFzbWVuLmdvLmlkLyxodHRwczovL3VsdC5hdW0uc3RhZ2luZy5iZWxhamFyLmlkLyxodHRwOi8vbG9jYWxob3N0OjMwMDAvLGh0dHBzOi8vcHVzYXRpbmZvcm1hc2kudWx0LmtlbWVuZGlrZGFzbWVuLmdvLmlkLyIsImtleSI6ImVvbzVXMzVaIn0=/embed/view/?jenis_layanan=Website ULT - Dasbor Pengaduan Publik" />
        </div>
      </div>
    </SingleLayout>
  )
}
